import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "app-logo" }


export default /*#__PURE__*/_defineComponent({
  __name: 'AppLogo',
  props: {
		width: {
			type: String,
			default: "w-10",
		},
	},
  setup(__props) {

	

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("img", {
      src: "/media/logos/Logo-Jahagal.svg",
      alt: "Logo Jahagal",
      class: _normalizeClass([__props.width])
    }, null, 2)
  ]))
}
}

})